import { useMutation } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { User } from '../types/user';
import customFetch from '../utils/fetch';
export const useCreateOrUpdateUser = (email: string, roles: string[]) => {
  const {
    mutate,
    data,
    isPending,
    isSuccess,
    isError,
    error
  } = useMutation({
    mutationKey: ['createOrUpdateUser', email, roles],
    mutationFn: async ({
      email,
      roles
    }: {
      email: string;
      roles: string[];
    }) => {
      const response = await customFetch(`${BASE_API_URL}/user`, {
        method: 'POST',
        body: JSON.stringify({
          email,
          roles
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const {
        success,
        error,
        data
      } = (await response.json() as {
        success: boolean;
        error: string;
        data: User[];
      });
      if (!response.ok || !success) {
        throw new Error(`Failed on user request: ${error}`);
      }
      return {
        data
      };
    }
  });
  return {
    createOrUpdateUser: mutate,
    actionStatus: data,
    isPending,
    isSuccess,
    isError,
    error
  };
};